export const ADD_NAVIGATION_ITEM = 'ADD_NAVIGATION_ITEM';
export const REMOVE_NAVIGATION_ITEM = 'REMOVE_NAVIGATION_ITEM';

/**
 * Add custom navigation item.
 * @function addNavigationItem
 * @param {Object} item Data.
 * @returns {Object} Get custom navigation results action.
 */

export const addNavigationItem = (item) => ({
    type: ADD_NAVIGATION_ITEM,
    payload: item,
});


/**
 * Remove custom navigation item by id.
 * @function removeNavigationItem
 * @param {Object} key key to remove.
 * @returns {Object} Get custom navigation results action.
 */

export const removeNavigationItem = (key) => ({
    type: REMOVE_NAVIGATION_ITEM,
    key: key,
});